import { NgModule } from '@angular/core';

import { AccountInformationSelectSearchComponent } from './account-information-select-search.component';
import { AirportsSelectSearchComponent } from './airports-select-search.component';
import { BusinessGroupsSelectSearchComponent } from './business-group-select-search.component';
import { CardNumberInformationSelectSearchComponent } from './card-number-information-select-search.component';
import { ContactColumnSearchComponent } from './contact-column-select-search.component';
import { CustomFieldSelectSearchComponent } from './custom-field-select-search.component';
import { CustomSelectSearchComponent } from './custom-select-search.component';
import { CustomerDomainSelectSearchComponent } from './customer-domain-select-search.component';
import { DeliveryStatusSelectSearchComponent } from './delivery-status-select-search.component';
import { DynamicTemplateSelectSearchComponent } from './dynamic-template-select-search.component';
import { EnumSelectSearchComponent } from './enum-select-search.component';
import { GetApisSelectSearchComponent } from './get-apis-select-search.component';
import { GroupPriceCategorySearchComponent } from './group-price-category-select-search.component';
import { GroupPriceSelectSearchComponent } from './group-price-select-search.component';
import { GuildSelectSearchComponent } from './guild-select-search.component';
import { InboxGroupSelectSearchComponent } from './inbox-group-select-search.component';
import { MenuSelectSearchComponent } from './menu-select-search.component';
import { OrganizationCustomFieldSelectSearchComponent } from './organization-custom-field-select-search.component';
import { OrganizationSelectSearchComponent } from './organization-select-search.component';
import { PhoneBookSelectSearchComponent } from './phonebook-select-search.component';
import { PrivateNumberForStatisticsSelectSearchComponent } from './private-number-for-statistics-select-search.component';
import { PrivateNumberSelectSearchComponent } from './private-number-select-search.component';
import { ProvinceSelectSearchComponent } from './province-select-search.component';
import { PublicPlaceSelectSearchComponent } from './public-places-select-search.component';
import { PublicPlaceSubCategorySelectSearchComponent } from './public-places-sub-category-select-search.component';
import { PublicReceiveKeywordSelectSearchComponent } from './public-receive-keyword-select-search.component';
import { RegionsSelectSearchComponent } from './regions-select-search.component';
import { ResellersSelectSearchComponent } from './resellers-select-search.component';
import { RoleSelectSearchComponent } from './role-select-search.component';
import { SmartSmsCampaignsSelectSearchComponent } from './smart-sms-campaigns-select-search.component';
import { SmartSmsClubsSelectSearch } from './smart-sms-clubs-select-search.component';
import { SmsSenderAgentSelectSearchComponent } from './sms-sender-agent-select-search.component';
import { SmsTemplateGroupSelectSearchComponent } from './sms-template-group-select-search.component';
import { SocialMediaApplicationsSelectSearchComponent } from './social-media-applications-select-search.component';
import { SocialMediaMessagesSelectSearchComponent } from './social-media-messages-select-search.component';
import { UserSelectSearchComponent } from './user-select-search.component';
import { VoiceMessagesSelectSearchComponent } from './voice-messages-select-search.component';
import { WebhookSelectSearchComponent } from './webhook-select-search.component';
import { WhiteMessagePrivateNumberSelectSearchComponent } from './white-message-private-number-select-search.component';
import { ZonePostalCodesSelectSearchComponent } from './zone-postal-codes-select-search.component';
import { ZonesSelectSearchComponent } from './zones-select-search.component';
import { RefundDeliveryStatusesSelectSearchComponent } from './refund-delivery-statuses-select-search.component';
import { VoiceMessageGroupsSelectSearchComponent } from './voice-message-groups-select-search.component';
import { BrandSelectSearchComponent } from './brand-select-search.component';
import { StrategiesListSelectSearchComponent } from './strategies-list-select-search.component';
import { FormBuilderFieldsSelectSearchComponent } from './form-builder-fields-select-search.component';

@NgModule({
  declarations: [],
  imports: [
    AccountInformationSelectSearchComponent,
    AirportsSelectSearchComponent,
    BusinessGroupsSelectSearchComponent,
    CardNumberInformationSelectSearchComponent,
    ContactColumnSearchComponent,
    CustomFieldSelectSearchComponent,
    DynamicTemplateSelectSearchComponent,
    GetApisSelectSearchComponent,
    GroupPriceCategorySearchComponent,
    GroupPriceSelectSearchComponent,
    GuildSelectSearchComponent,
    InboxGroupSelectSearchComponent,
    OrganizationSelectSearchComponent,
    OrganizationCustomFieldSelectSearchComponent,
    PhoneBookSelectSearchComponent,
    PrivateNumberForStatisticsSelectSearchComponent,
    PrivateNumberSelectSearchComponent,
    ProvinceSelectSearchComponent,
    PublicPlaceSelectSearchComponent,
    PublicPlaceSubCategorySelectSearchComponent,
    RegionsSelectSearchComponent,
    ResellersSelectSearchComponent,
    RoleSelectSearchComponent,
    SmsSenderAgentSelectSearchComponent,
    SmartSmsCampaignsSelectSearchComponent,
    SmartSmsClubsSelectSearch,
    SmsTemplateGroupSelectSearchComponent,
    SocialMediaMessagesSelectSearchComponent,
    MenuSelectSearchComponent,
    SocialMediaApplicationsSelectSearchComponent,
    UserSelectSearchComponent,
    VoiceMessagesSelectSearchComponent,
    WebhookSelectSearchComponent,
    ZonePostalCodesSelectSearchComponent,
    ZonesSelectSearchComponent,
    PublicReceiveKeywordSelectSearchComponent,
    CustomerDomainSelectSearchComponent,
    WhiteMessagePrivateNumberSelectSearchComponent,
    EnumSelectSearchComponent,
    CustomSelectSearchComponent,
    DeliveryStatusSelectSearchComponent,
    RefundDeliveryStatusesSelectSearchComponent,
    VoiceMessageGroupsSelectSearchComponent,
    BrandSelectSearchComponent,
    StrategiesListSelectSearchComponent,
    FormBuilderFieldsSelectSearchComponent,
  ],
  exports: [
    AccountInformationSelectSearchComponent,
    AirportsSelectSearchComponent,
    BusinessGroupsSelectSearchComponent,
    CardNumberInformationSelectSearchComponent,
    ContactColumnSearchComponent,
    CustomFieldSelectSearchComponent,
    DynamicTemplateSelectSearchComponent,
    GetApisSelectSearchComponent,
    GroupPriceCategorySearchComponent,
    GroupPriceSelectSearchComponent,
    GuildSelectSearchComponent,
    InboxGroupSelectSearchComponent,
    OrganizationSelectSearchComponent,
    OrganizationCustomFieldSelectSearchComponent,
    PhoneBookSelectSearchComponent,
    PrivateNumberForStatisticsSelectSearchComponent,
    PrivateNumberSelectSearchComponent,
    ProvinceSelectSearchComponent,
    PublicPlaceSelectSearchComponent,
    PublicPlaceSubCategorySelectSearchComponent,
    RegionsSelectSearchComponent,
    ResellersSelectSearchComponent,
    RoleSelectSearchComponent,
    SmsSenderAgentSelectSearchComponent,
    SmartSmsCampaignsSelectSearchComponent,
    SmartSmsClubsSelectSearch,
    SmsTemplateGroupSelectSearchComponent,
    SocialMediaMessagesSelectSearchComponent,
    MenuSelectSearchComponent,
    SocialMediaApplicationsSelectSearchComponent,
    UserSelectSearchComponent,
    VoiceMessagesSelectSearchComponent,
    WebhookSelectSearchComponent,
    ZonePostalCodesSelectSearchComponent,
    ZonesSelectSearchComponent,
    PublicReceiveKeywordSelectSearchComponent,
    CustomerDomainSelectSearchComponent,
    WhiteMessagePrivateNumberSelectSearchComponent,
    EnumSelectSearchComponent,
    CustomSelectSearchComponent,
    DeliveryStatusSelectSearchComponent,
    RefundDeliveryStatusesSelectSearchComponent,
    VoiceMessageGroupsSelectSearchComponent,
    BrandSelectSearchComponent,
    StrategiesListSelectSearchComponent,
    FormBuilderFieldsSelectSearchComponent,
  ],
})
export class SelectSearchModule {}
